module.exports = __webpack_public_path__ + "static/media/germanyYes.2eb81fa1.jpg";